import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Writes to the clipboard and reports only what actually happened.
 *
 * `navigator.clipboard.writeText` rejects when the document is not focused, so
 * a handler that toasts synchronously announces a copy that did not happen.
 * Extracted from the bank account rows when the API secret dialog turned out to
 * be the second surface handing a value over for a person to paste.
 */
export const useCopyToClipboard = (copiedMessage: string) => {
  const { t } = useTranslation();

  return (value: string) => {
    // The call is INSIDE the chain because navigator.clipboard is undefined on
    // an insecure origin: reading .writeText throws synchronously, before a
    // promise exists to catch it, and the failure toast never fires.
    void Promise.resolve()
      .then(() => navigator.clipboard.writeText(value))
      .then(() => toast.success(copiedMessage))
      .catch(() => toast.error(t("Unable to copy")));
  };
};

export default useCopyToClipboard;
